import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { render } from 'react-dom';
import SignupForm from './SignupForm';
import SignupModal from './SignupModal';
import './style.css';
import translations from './translations.yml';
import { addTranslations } from '../../Utils/Locale';
import { setPartner } from './Locale';
addTranslations(translations);
const signupFormElement = document.querySelector('#signup_form');
if (signupFormElement) {
    const partner = JSON.parse(signupFormElement.getAttribute('data-partner'));
    const urlParams = new URLSearchParams(window.location.search);
    setPartner(partner);
    render(_jsx(SignupForm, { partner: partner, branches: JSON.parse(signupFormElement.getAttribute('data-branches')), isAdvisor: urlParams.get('advisor') !== '0', forceAdvisorField: partner.showAdvisorOnUserOnboarding }), signupFormElement);
}
const signupModalElement = document.querySelector('#signup_modal');
if (signupModalElement) {
    render(_jsx(SignupModal, { email: signupModalElement.getAttribute('data-email'), name: signupModalElement.getAttribute('data-name'), isNewUser: signupModalElement.getAttribute('data-is-new-user') === '1', partner: JSON.parse(signupModalElement.getAttribute('data-partner')) }), signupModalElement);
}
